export function getProviderNetworkFailure(headers?: Headers) {
  return (
    !!headers &&
    headers
      .entries()
      .some(
        ([key, value]) =>
          !!(key === "failed-integrations" && value === "provider-network")
      )
  );
}
